import { useVeltClient, VeltSidebarButton, VeltHuddle, VeltPresence, VeltCommentTool, VeltHuddleTool } from '@veltdev/react';
import { useEffect, useState } from 'react';

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('bridgecrew-unique-id');
    }
  }, [client]);

  return (
    <>
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
  <title>Bridgecrew | Projects</title>
  <div id="root" style={{ overflowX: "hidden" }}>
    <div className="App__appContainer__367qg bc-app">
      <div data-test-id="side-bar" className="side-bar__sideBar__EJrp6">
        <div
          className="Box__BoxRoot-sc-7gdahw-0 UibIj Flex__FlexRoot-iew4t-0 bc-component"
          display="flex"
        >
          <div
            className="Box__BoxRoot-sc-7gdahw-0 frMOvz bc-component"
            size={6}
          />
          <svg
            width={40}
            height={34}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Bridgecrew Logo"
            role="navigation"
            cursor="pointer"
            className="Logo__BcLogo-abad0h-0 eemFln"
          >
            <g clipPath="url(#BcLogo_inline_svg__clip0_535_1158)">
              <mask
                id="BcLogo_inline_svg__a"
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={17}
                height={32}
                style={{ maskType: "alpha" }}
              >
                <path d="M0 .663h16.282v31.32H0V.662z" fill="#fff" />
              </mask>
              <g mask="url(#BcLogo_inline_svg__a)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.282 4.498L8.707 1.445S-1.707-2.752.243 8.305l3.309 18.764s.549 3.112 2.31 4.913c-2.089-2.345.23-7.073.23-7.073l9.042-18.443c.372-.76.756-1.41 1.148-1.968z"
                  fill="#052882"
                />
              </g>
              <mask
                id="BcLogo_inline_svg__b"
                maskUnits="userSpaceOnUse"
                x={5}
                y={1}
                width={35}
                height={33}
                style={{ maskType: "alpha" }}
              >
                <path d="M5.863 1.623h34.085V33.27H5.863V1.623z" fill="#fff" />
              </mask>
              <g mask="url(#BcLogo_inline_svg__b)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M37.629 18.426L27.07 5.167s-5.98-7.507-10.789-.669l7.971 3.213c10.413 4.198 2.064 11.704 2.064 11.704L13.85 30.62c-2.072 1.863-3.75 2.581-5.102 2.61.926.089 2.062.03 3.451-.218l21.37-3.825s11.053-1.978 4.059-10.761zM5.863 31.982c.165.186.36.356.584.509a4.779 4.779 0 01-.584-.509z"
                  fill="#662EFF"
                />
              </g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.253 7.711l-7.971-3.213a14.565 14.565 0 00-1.148 1.968L6.09 24.909s-2.318 4.729-.228 7.073c.181.185.376.356.584.509.558.379 1.308.644 2.302.739 1.352-.029 3.03-.747 5.102-2.61l12.466-11.205s8.35-7.506-2.064-11.704z"
                fill="#00137D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.605 13.178a6.439 6.439 0 00-3.536 1.06V8.243H7.167v10.239c0 1.778.179 3.393 1.243 4.877a6.464 6.464 0 003.787 2.536 6.346 6.346 0 001.408.157 6.445 6.445 0 006.438-6.438 6.445 6.445 0 00-6.438-6.437zm3.574 6.437a3.578 3.578 0 01-3.574 3.575 3.578 3.578 0 01-3.574-3.575 3.578 3.578 0 013.574-3.574 3.578 3.578 0 013.574 3.574z"
                fill="#FEFEFE"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.105 22.45c-.629.484-1.38.74-2.173.74a3.578 3.578 0 01-3.574-3.575 3.578 3.578 0 013.574-3.574c.704 0 1.377.205 1.958.589l.434.317 2.03-2.03-.328-.27a6.448 6.448 0 00-4.094-1.47 6.445 6.445 0 00-6.438 6.438 6.445 6.445 0 006.438 6.438 6.448 6.448 0 004.13-1.501l.337-.283-2.025-2.025-.269.206z"
                fill="#FEFEFE"
              />
            </g>
            <defs>
              <clipPath id="BcLogo_inline_svg__clip0_535_1158">
                <path
                  fill="#fff"
                  transform="translate(0 .663)"
                  d="M0 0h40v32.673H0z"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className="side-bar__menu_items_wrapper__hJW3H">
          <div className="side-bar__menu_upper_container__2JnlD">
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Dashboard
              </span>
              <div
                role="navigation"
                aria-label="Dashboard"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="dashboard"
                    d="M1963,121h-24a3,3,0,0,1-3-3V94a3,3,0,0,1,3-3h24a3,3,0,0,1,3,3v24A3,3,0,0,1,1963,121Zm-13-28h-12v9h12V93Zm0,11h-12v15h12V104Zm14-11h-12v15h12V93Zm0,17h-12v9h12v-9Z"
                    transform="translate(-1934 -91)"
                  />
                </svg>
              </div>
            </div>
            <div className="side-bar__incidentItemContainer__24kBz">
              <div className="bc-dashboard-tooltip__tooltip__3dYWn">
                <span
                  className="bc-dashboard-tooltip__tooltipText__2UlF2"
                  style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
                >
                  Incidents
                </span>
                <div
                  role="navigation"
                  aria-label="Incidents"
                  className="item__sideMenu_icon_container__3armz"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 35 35"
                    className="item__sideMenu_icon__2oLUj "
                  >
                    <path
                      id="violations"
                      d="M1150.44,123a13.365,13.365,0,0,1-11.69-7.03,14.491,14.491,0,0,1,2.15-16.791l0.08-.086a8.259,8.259,0,0,1,1.92-1.6,0.932,0.932,0,0,1,.45-0.114,1.079,1.079,0,0,1,.61.19c0.52,0.355.51,0.779,0.42,1.7l-0.05.5c-0.04.394-.09,0.856-0.12,1.359-0.13,1.194-.25,2.676-0.33,3.955a6.02,6.02,0,0,0,.04.914,3.432,3.432,0,0,0,2.85,2.567,3.323,3.323,0,0,0,.57.048,3.1,3.1,0,0,0,2.73-1.562,3.893,3.893,0,0,0,.13-3.584c-0.2-.382-0.4-0.785-0.6-1.19-0.12-.241-0.2-0.405-0.29-0.568s-0.16-.318-0.24-0.487c-1.74-3.643-1.69-7.686.11-10.548a1.474,1.474,0,0,1,1.11-.683l0.12,0a1.439,1.439,0,0,1,1.1.5c1.23,1.392,2.61,2.7,3.79,3.8,0.99,0.931,2.11,1.987,3.13,3.086,3.13,3.336,4.83,6.35,5.36,9.483a13.66,13.66,0,0,1-1.03,8.092A14,14,0,0,1,1150.98,123h-0.54Zm-8.87-21.513a12.474,12.474,0,0,0-1.15,13.431,11.738,11.738,0,0,0,10.01,5.916c0.15,0,.29,0,0.44-0.009a11.855,11.855,0,0,0,9.98-6.824,11.678,11.678,0,0,0,.89-6.788c-0.51-2.7-2.09-5.419-4.83-8.319-0.98-1.012-2.01-1.985-3.07-2.975l-0.61-.573c-0.84-.791-1.71-1.608-2.52-2.471l-0.21-.22-0.11.282a9.371,9.371,0,0,0,.51,7.393c0.08,0.159.16,0.306,0.23,0.454s0.15,0.307.23,0.46c0.1,0.221.22,0.46,0.33,0.7s0.23,0.47.34,0.7a6.117,6.117,0,0,1-.25,5.53,5.135,5.135,0,0,1-4.52,2.605,5.824,5.824,0,0,1-.94-0.078,5.512,5.512,0,0,1-4.57-4.231,6.018,6.018,0,0,1-.08-1.531l0.07-.9c0.06-.826.12-1.652,0.18-2.408l0.05-.65Z"
                      transform="translate(-1133 -89)"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Projects
              </span>
              <div
                role="navigation"
                aria-label="Projects"
                className="item__sideMenu_icon_container_selected__1Yu9Y"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon_selected__1gXWm "
                >
                  <path
                    id="violations"
                    d="M2869.02,191h-1.25a18.354,18.354,0,0,0-15.77,9.087c-0.18.31-.35,0.611-0.51,0.915l-6.05-.449a0.968,0.968,0,0,0-.76.3l-5.39,5.434a0.987,0.987,0,0,0,0,1.4,0.951,0.951,0,0,0,.65.29l7.14,0.231,0.33,0.331a8.03,8.03,0,0,0-4.34,7.143v0.687a0.987,0.987,0,0,0,.98.992h0.68a7.987,7.987,0,0,0,7.09-4.383l0.87,0.886,0.21,7.183a0.983,0.983,0,0,0,1.68.661l5.35-5.405a1,1,0,0,0,.29-0.77l-0.39-5.725c0.48-.241.96-0.506,1.42-0.793a18.411,18.411,0,0,0,8.75-15.758v-1.266A0.987,0.987,0,0,0,2869.02,191Zm-23.98,24.371a6.035,6.035,0,0,1,3.86-5.338l1.43,1.444A6.019,6.019,0,0,1,2845.04,215.371Zm22.99-22.114a16.421,16.421,0,0,1-9.63,15.044,0.991,0.991,0,0,0-.57.972l0.4,5.949-3.43,3.464-0.16-5.288a1.01,1.01,0,0,0-.28-0.661l-6.16-6.208a0.948,0.948,0,0,0-.65-0.291l-5.26-.169,3.45-3.5,6.27,0.456a0.975,0.975,0,0,0,.96-0.568c0.22-.453.45-0.916,0.72-1.365a16.4,16.4,0,0,1,14.08-8.112h0.27Zm-7.64,3.99a3.415,3.415,0,1,0,2.4,5.831h0a3.439,3.439,0,0,0,0-4.829A3.364,3.364,0,0,0,2860.39,197.247Zm1.01,4.43a1.414,1.414,0,0,1-2.01,0,1.448,1.448,0,0,1,0-2.024,1.414,1.414,0,0,1,2.01,0,1.461,1.461,0,0,1,.41,1.013,1.433,1.433,0,0,1-.4,1.021Z"
                    transform="translate(-2839 -191)"
                  />
                </svg>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Development Pipelines
              </span>
              <div
                role="navigation"
                aria-label="Development Pipelines"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="development-pipelines"
                    d="M2942.05,307.142l5.89,5.894-1.41,1.414-6.65-6.646a1.847,1.847,0,0,1,0-2.61l6.65-6.645,1.41,1.414-5.89,5.893A0.9,0.9,0,0,0,2942.05,307.142Zm24.9-1.286-5.89-5.891,1.41-1.414,6.64,6.643a1.847,1.847,0,0,1,0,2.61l-6.64,6.644-1.42-1.414,5.9-5.892A0.919,0.919,0,0,0,2966.95,305.856ZM2954.48,291a0.988,0.988,0,0,1,.99.989v29.022a0.985,0.985,0,1,1-1.97,0V291.989A0.985,0.985,0,0,1,2954.48,291Z"
                    transform="translate(-2937.005 -291)"
                  />
                </svg>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Supply Chain
              </span>
              <div
                role="navigation"
                aria-label="Supply Chain"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="supplyChain"
                    d="M1460.82,111.657a5.177,5.177,0,0,0-3.15,1.077l-4.29-4.294a9.6,9.6,0,0,0,.21-1.946,9.327,9.327,0,0,0-.13-1.5l4.51-4.518a5.179,5.179,0,1,0-1.46-1.46l-3.72,3.725a9.3,9.3,0,1,0-.17,7.864l3.7,3.7A5.158,5.158,0,1,0,1460.82,111.657Zm0-18.589a3.1,3.1,0,1,1-3.1,3.1A3.1,3.1,0,0,1,1460.82,93.068Zm-16.53,20.655a7.229,7.229,0,1,1,7.23-7.229A7.242,7.242,0,0,1,1444.29,113.723Zm16.53,6.2a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,1460.82,119.919Z"
                    transform="translate(-1432.985 -89)"
                  />
                </svg>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Resource Inventory
              </span>
              <div
                role="navigation"
                aria-label="Resource Inventory"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="query"
                    d="M2966.99,222h-7.97a2.968,2.968,0,0,1-3.01-2.917v-6.173a2.968,2.968,0,0,1,3.01-2.918h2.99v-3.049h-15.02v3.049h2.99a2.968,2.968,0,0,1,3.01,2.918v6.173a2.968,2.968,0,0,1-3.01,2.917H2942a2.966,2.966,0,0,1-3-2.917v-6.173a2.966,2.966,0,0,1,3-2.918h3v-4.006a0.987,0.987,0,0,1,.99-0.987,0.95,0.95,0,0,1,.35.071c0.02,0,.03-0.008.04-0.008h7.17v-2.8a1,1,0,0,1,.05-0.247h-2.59a2.959,2.959,0,0,1-3-2.917v-5.173a2.96,2.96,0,0,1,3-2.918h6.98a2.96,2.96,0,0,1,3,2.918v5.173a2.959,2.959,0,0,1-3,2.917h-2.59a1,1,0,0,1,.05.247v2.8h7.01a0.991,0.991,0,0,1,.14.028A0.961,0.961,0,0,1,2963,205a0.987,0.987,0,0,1,.99.987v4.006h3a2.968,2.968,0,0,1,3.01,2.918v6.173A2.968,2.968,0,0,1,2966.99,222Zm-9.06-21.994a1.048,1.048,0,0,0,1.08-1.017v-4.962a1.048,1.048,0,0,0-1.08-1.017h-6.86a1.048,1.048,0,0,0-1.08,1.017v4.962a1.048,1.048,0,0,0,1.08,1.017h6.86ZM2942.07,212a1.049,1.049,0,0,0-1.08,1.018v5.962a1.048,1.048,0,0,0,1.08,1.017h7.85a1.048,1.048,0,0,0,1.08-1.017v-5.962a1.049,1.049,0,0,0-1.08-1.018h-7.85Zm25.94,1.018a1.049,1.049,0,0,0-1.08-1.018h-7.85a1.058,1.058,0,0,0-1.09,1.018v5.962a1.057,1.057,0,0,0,1.09,1.017h7.85a1.048,1.048,0,0,0,1.08-1.017v-5.962Z"
                    transform="translate(-2937 -191)"
                  />
                </svg>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Policies
              </span>
              <div
                role="navigation"
                aria-label="Policies"
                data-test-id="side-bar-policies"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="policies"
                    d="M2654.48,324.015c-12.4-5.318-17.04-13.451-15-28.537,0.26,0,.5,0,0.75,0,5.75,0,9.97-1.916,14.25-6.5,4.28,4.58,8.5,6.5,14.25,6.5q0.375,0,.75,0C2671.68,310.551,2667.03,318.685,2654.48,324.015Zm13.45-26.284-0.05-.548-0.55-.016c-5.44-.169-9.04-2.453-12.44-5.428l-0.41-.358-0.41.358c-3.4,2.971-6.99,5.254-12.42,5.428l-0.55.018-0.05.552c-1.18,12.683,2.88,19.494,13.17,24.321l0.26,0.125,0.27-.123C2665.17,317.223,2669.24,310.41,2667.93,297.731Zm-12.31,11.11v4.6a1,1,0,0,1-1,1h-0.24a1,1,0,0,1-1-1v-4.6A4.5,4.5,0,1,1,2655.62,308.841ZM2654.5,302a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,2654.5,302Z"
                    transform="translate(-2637 -289)"
                  />
                </svg>
              </div>
            </div>
            <div className="bc-dashboard-tooltip__tooltip__3dYWn">
              <span
                className="bc-dashboard-tooltip__tooltipText__2UlF2"
                style={{ top: "32%", left: "130%", transitionDelay: "0s" }}
              >
                Integrations
              </span>
              <div
                role="navigation"
                aria-label="Integrations"
                data-test-id="side-bar-integration"
                className="item__sideMenu_icon_container__3armz"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="integrations"
                    d="M1864.43,114.924a1.993,1.993,0,0,1,1.57,1.953V122a2,2,0,0,1-2,2h-27a2,2,0,0,1-2-2V99.107a2,2,0,0,1,2-2h8.23c-0.55-.916-0.84-0.968-0.84-2.057A6.014,6.014,0,0,1,1850.5,89a6.087,6.087,0,0,1,6.11,6.051c0,1.071-.28,1.109-0.85,2.057H1864a2,2,0,0,1,2,2v5.325a2,2,0,0,1-1.56,1.951,4.355,4.355,0,0,0-3.42,4.267A4.445,4.445,0,0,0,1864.43,114.924ZM1864,104.432V99.108h-12.05l2.02-2.9c0.42-.637.64-0.382,0.64-1.155A4.083,4.083,0,0,0,1850.5,91a4.04,4.04,0,0,0-4.11,4.051c0,0.774.22,0.52,0.64,1.154l2.02,2.9H1837V122h27v-5.123a6.469,6.469,0,0,1-4.98-6.227A6.368,6.368,0,0,1,1864,104.432Z"
                    transform="translate(-1833 -89)"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="side-bar__menu_lower_container__3ybUr">
            <div
              className="Box__BoxRoot-sc-7gdahw-0 fNcFGU Flex__FlexRoot-iew4t-0 bc-component"
              display="flex"
            >
              <div className="item__sideMenu_icon_container__3armz">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 35 35"
                  className="item__sideMenu_icon__2oLUj "
                >
                  <path
                    id="notifications"
                    d="M2866,317h-7v0.5a4.5,4.5,0,0,1-9,0V317h-7a4,4,0,0,1,0-8v-5.5a11.5,11.5,0,0,1,8-10.954V292.5a3.5,3.5,0,0,1,7,0v0.046a11.5,11.5,0,0,1,8,10.954V309A4,4,0,0,1,2866,317Zm-14.62.17a3.12,3.12,0,0,0,6.24,0V317h-6.24v0.17ZM2866,311h-2v-7.5a9.495,9.495,0,0,0-8-9.37V292.5a1.5,1.5,0,0,0-3,0v1.63a9.495,9.495,0,0,0-8,9.37V311h-2a2,2,0,0,0,0,4h23A2,2,0,0,0,2866,311Z"
                    transform="translate(-2836 -289)"
                  />
                </svg>
                <div className="unreadItemsCounter__unreadIncidentCounterContainer__2uNvj">
                  <div className="unreadItemsCounter__IncidentDot__8PU1K">
                    1
                  </div>
                </div>
              </div>
              <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Popover__Root-sc-9h3h9j-0 hgsDoH bc-component">
                <div
                  className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Popover__ReferenceElement-sc-9h3h9j-2 hrMIog bc-component"
                  display="flex"
                >
                  <div
                    className="item__sideMenu_menu_container__ZYrXU"
                    role="navigation"
                    aria-label="Open Settings Menu"
                  >
                    <div className="bc-dashboard-tooltip__tooltip__3dYWn">
                      <span
                        className="bc-dashboard-tooltip__tooltipText__2UlF2"
                        style={{ top: "18%", left: "210%" }}
                      >
                        Settings
                      </span>
                      <div
                        className="Box__BoxRoot-sc-7gdahw-0 iYYAMZ Flex__FlexRoot-iew4t-0 Avatar__AvatarRoot-sc-29ay4d-0 laNlGu bc-component"
                        display="inline-flex"
                        fontWeight="semiBold"
                        fontFamily="body"
                      >
                        BL
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="notificationsList__ListContainer-qvqe0j-0 cWcwWC" />
      <div
        className="Box__BoxRoot-sc-7gdahw-0 bgawP Flex__FlexRoot-iew4t-0 bc-component"
        display="flex"
        width="100%"
      >
        <div
          className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component"
          style={{
            borderBottom: "1px solid",
            borderBlockColor: "rgb(232, 234, 239)",
            minWidth: "100%"
          }}
        >
          <div
            className="Box__BoxRoot-sc-7gdahw-0 fYNfjg Flex__FlexRoot-iew4t-0 fVShnb bc-component"
            display="flex"
            role="alert"
          >
            <div
              className="Box__BoxRoot-sc-7gdahw-0 jYbLBz Flex__FlexRoot-iew4t-0 bc-component"
              display="flex"
              width="100%"
            >
              <div
                className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fQPitA bc-component"
                display="flex"
              >
                <span
                  color="grey.700"
                  className="Text__BCTextRoot-shaear-0 cjUHfn"
                >
                  Bridgecrew has been fully integrated into Prisma Cloud with a
                  powerful code to cloud experience. As a part of the
                  transition, we will be shutting down Bridgecrew standalone
                  edition at the end of 2023. Please upgrade to Prisma Cloud
                  Enterprise Edition before the end of the year.
                </span>
                <button
                  className="LinkButton__LinkButtonRoot-zhdzys-1"
                  style={{ whiteSpace: "nowrap", marginRight: 10 }}
                >
                  <span
                    color="grey.700"
                    fontWeight="semiBold"
                    className="Text__BCTextRoot-shaear-0 oZWdS LinkButton__Content-zhdzys-0 eZQMZx"
                  >
                    Read More
                  </span>
                </button>
              </div>
            </div>
            <div
              className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 bc-component"
              display="flex"
            >
              <i
                className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                display="flex"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 9.97 9.969"
                  className="Icon__IconGraphics-sc-384m4t-0 hMpnlY Notice__BCCloseIcon-sc-19icdr5-0 HBFem"
                >
                  <path
                    className="Close_inline_svg__cls-1"
                    d="M5.96 4.961l3.79 3.786a.708.708 0 01-1 1L4.96 5.961 1.17 9.747a.708.708 0 01-1-1l3.79-3.786L.17 1.175a.708.708 0 011-1l3.79 3.786L8.75.175a.708.708 0 111 1z"
                  />
                </svg>
              </i>
            </div>
          </div>
        </div>
        <div
          className="Box__BoxRoot-sc-7gdahw-0 iUDzjr Flex__FlexRoot-iew4t-0 bc-component"
          display="flex"
        >
          <div className="SplitPane__Root-sc-10avc5m-1 korzRb">
            <div className="sc-iBkjds ecJpcq SplitPane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 jxDNWv">
              <div
                className="sc-bczRLJ doUjVv Pane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 jxDNWv"
                style={{ flexBasis: "238.2px" }}
              >
                <div
                  className="sc-dkzDqf jinsNC"
                  style={{ background: "rgba(220, 220, 220, 0.1)" }}
                />
                <div className="sc-gsnTZi GJlVj" style={{ minWidth: 50 }}>
                  <div
                    className="Box__BoxRoot-sc-7gdahw-0 hxhkdI bc-component"
                    height="100%"
                    overflow="auto"
                  >
                    <div className="Box__BoxRoot-sc-7gdahw-0 lbKchh bc-component">
                      <div
                        className="Box__BoxRoot-sc-7gdahw-0 kLzkqY Flex__FlexRoot-iew4t-0 fQPitA bc-component"
                        display="flex"
                      >
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 FilterSection__Root-sc-18ts49r-0 bCtSFH bc-component"
                          display="flex"
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 fEaIng bc-component">
                            <div
                              className="Box__BoxRoot-sc-7gdahw-0 glgcNz Flex__FlexRoot-iew4t-0 ePZMDm FilterContainer__StyledContainer-qjk6kn-0 gjFkrA bc-component"
                              display="flex"
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 eCACOE Flex__FlexRoot-iew4t-0 bc-component"
                                display="flex"
                              >
                                <span
                                  color="grey.700"
                                  className="Text__BCTextRoot-shaear-0 fCMqan"
                                >
                                  Repositories
                                </span>
                              </div>
                              <div className="Box__BoxRoot-sc-7gdahw-0 CTthg bc-component">
                                <button
                                  className="Box__BoxRoot-sc-7gdahw-0 ebRxGE Flex__FlexRoot-iew4t-0 BCSelectToggle__Root-sc-182zso2-1 jvgMQS bc-component"
                                  display="flex"
                                  type="button"
                                  width="100%"
                                  height={38}
                                  label="Repositories"
                                >
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 jjhQdt Flex__FlexRoot-iew4t-0 fVShnb BCSelectToggle__SelectedContent-sc-182zso2-0 dzzFfB bc-component"
                                    display="flex"
                                  >
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                      display="flex"
                                    >
                                      <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                        <i
                                          className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                          display="flex"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 15.031 15.031"
                                            className="Icon__IconGraphics-sc-384m4t-0 cuZydI"
                                          >
                                            <path
                                              d="M14.815 14.815a.739.739 0 01-1.044 0l-2.989-2.984a6.642 6.642 0 111.049-1.048l2.989 2.988a.739.739 0 01-.005 1.044zM10.291 2.984a5.167 5.167 0 100 7.307 5.167 5.167 0 000-7.307z"
                                              fillRule="evenodd"
                                            />
                                          </svg>
                                        </i>
                                      </div>
                                      <span
                                        color="grey.500"
                                        className="Text__BCTextRoot-shaear-0 WKNyu Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                      >
                                        <span>Search</span>
                                      </span>
                                    </div>
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 dbsjGM styled__ToggleButton-s2ioeg-0 VDjsJ bc-component"
                                      role="img"
                                    >
                                      <i
                                        className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                        display="flex"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 16.969 16.969"
                                          className="Icon__IconGraphics-sc-384m4t-0 docJds"
                                        >
                                          <path
                                            d="M16.509 6.143l-6.926 6.869a1.561 1.561 0 01-2.2 0L.457 6.143a1.544 1.544 0 010-2.19 1.561 1.561 0 012.2 0l5.827 5.774 5.827-5.774a1.56 1.56 0 012.2 0 1.544 1.544 0 01-.002 2.19z"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                      </i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 FilterSection__Root-sc-18ts49r-0 bCtSFH bc-component"
                          display="flex"
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 fEaIng bc-component">
                            <div
                              className="Box__BoxRoot-sc-7gdahw-0 glgcNz Flex__FlexRoot-iew4t-0 ePZMDm FilterContainer__StyledContainer-qjk6kn-0 gjFkrA bc-component"
                              display="flex"
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 eCACOE Flex__FlexRoot-iew4t-0 bc-component"
                                display="flex"
                              >
                                <span
                                  color="grey.700"
                                  className="Text__BCTextRoot-shaear-0 fCMqan"
                                >
                                  Branch
                                </span>
                              </div>
                              <div className="Box__BoxRoot-sc-7gdahw-0 CTthg bc-component">
                                <button
                                  className="Box__BoxRoot-sc-7gdahw-0 ebRxGE Flex__FlexRoot-iew4t-0 BCSelectToggle__Root-sc-182zso2-1 iUATFZ bc-component"
                                  display="flex"
                                  type="button"
                                  width="100%"
                                  disabled=""
                                  height={38}
                                  label="Branch"
                                >
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 jjhQdt Flex__FlexRoot-iew4t-0 fVShnb BCSelectToggle__SelectedContent-sc-182zso2-0 dzzFfB bc-component"
                                    display="flex"
                                  >
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                      display="flex"
                                    >
                                      <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                        <i
                                          className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                          display="flex"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 15.031 15.031"
                                            className="Icon__IconGraphics-sc-384m4t-0 cuZydI"
                                          >
                                            <path
                                              d="M14.815 14.815a.739.739 0 01-1.044 0l-2.989-2.984a6.642 6.642 0 111.049-1.048l2.989 2.988a.739.739 0 01-.005 1.044zM10.291 2.984a5.167 5.167 0 100 7.307 5.167 5.167 0 000-7.307z"
                                              fillRule="evenodd"
                                            />
                                          </svg>
                                        </i>
                                      </div>
                                      <span
                                        color="grey.500"
                                        className="Text__BCTextRoot-shaear-0 WKNyu Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                      >
                                        <span>default</span>
                                      </span>
                                    </div>
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 dbsjGM styled__ToggleButton-s2ioeg-0 VDjsJ bc-component"
                                      role="img"
                                    >
                                      <i
                                        className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                        display="flex"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 16.969 16.969"
                                          className="Icon__IconGraphics-sc-384m4t-0 docJds"
                                        >
                                          <path
                                            d="M16.509 6.143l-6.926 6.869a1.561 1.561 0 01-2.2 0L.457 6.143a1.544 1.544 0 010-2.19 1.561 1.561 0 012.2 0l5.827 5.774 5.827-5.774a1.56 1.56 0 012.2 0 1.544 1.544 0 01-.002 2.19z"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                      </i>
                                    </div>
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 FilterSection__Root-sc-18ts49r-0 bCtSFH bc-component"
                          display="flex"
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 fEaIng bc-component">
                            <div
                              className="Box__BoxRoot-sc-7gdahw-0 glgcNz Flex__FlexRoot-iew4t-0 ePZMDm FilterContainer__StyledContainer-qjk6kn-0 gjFkrA bc-component"
                              display="flex"
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 eCACOE Flex__FlexRoot-iew4t-0 bc-component"
                                display="flex"
                              >
                                <span
                                  color="grey.700"
                                  className="Text__BCTextRoot-shaear-0 fCMqan"
                                >
                                  Issue Status
                                </span>
                              </div>
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 dbsjGM RadioGroup__BCRadioGroup-hlv68d-0 fAGAwh bc-component"
                                role="radiogroup"
                              >
                                <div
                                  className="Box__BoxRoot-sc-7gdahw-0 gVjYRm Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                  display="flex"
                                >
                                  <label
                                    className="Box__BoxRoot-sc-7gdahw-0 gRlvMz Flex__FlexRoot-iew4t-0 Radio__WrapperRadio-sc-191s7yy-0 uJBon bc-component"
                                    display="flex"
                                    width="max-content"
                                  >
                                    <input
                                      name="checkStatus"
                                      type="radio"
                                      className="Radio__HiddenRadio-sc-191s7yy-1 gWDgbZ"
                                      defaultValue="Error"
                                      defaultChecked=""
                                    />
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 kgVoLO Radio__RadioRoot-sc-191s7yy-3 hAtPZQ bc-component"
                                      color="secondary"
                                      aria-checked="true"
                                    />
                                    <div className="Box__BoxRoot-sc-7gdahw-0 fJqNaH Radio__LabelRadio-sc-191s7yy-2 hFQfGJ bc-component">
                                      <span
                                        color="grey.700"
                                        className="Text__BCTextRoot-shaear-0 cjUHfn"
                                      >
                                        Error
                                      </span>
                                    </div>
                                  </label>
                                  <label
                                    className="Box__BoxRoot-sc-7gdahw-0 gRlvMz Flex__FlexRoot-iew4t-0 Radio__WrapperRadio-sc-191s7yy-0 uJBon bc-component"
                                    display="flex"
                                    width="max-content"
                                  >
                                    <input
                                      name="checkStatus"
                                      type="radio"
                                      className="Radio__HiddenRadio-sc-191s7yy-1 gWDgbZ"
                                      defaultValue="Passed"
                                    />
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 kgVoLO Radio__RadioRoot-sc-191s7yy-3 lafHvY bc-component"
                                      color="secondary"
                                      aria-checked="false"
                                    />
                                    <div className="Box__BoxRoot-sc-7gdahw-0 fJqNaH Radio__LabelRadio-sc-191s7yy-2 hFQfGJ bc-component">
                                      <span
                                        color="grey.700"
                                        className="Text__BCTextRoot-shaear-0 cjUHfn"
                                      >
                                        Passed
                                      </span>
                                    </div>
                                  </label>
                                  <label
                                    className="Box__BoxRoot-sc-7gdahw-0 gRlvMz Flex__FlexRoot-iew4t-0 Radio__WrapperRadio-sc-191s7yy-0 uJBon bc-component"
                                    display="flex"
                                    width="max-content"
                                  >
                                    <input
                                      name="checkStatus"
                                      type="radio"
                                      className="Radio__HiddenRadio-sc-191s7yy-1 gWDgbZ"
                                      defaultValue="Suppressed"
                                    />
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 kgVoLO Radio__RadioRoot-sc-191s7yy-3 lafHvY bc-component"
                                      color="secondary"
                                      aria-checked="false"
                                    />
                                    <div className="Box__BoxRoot-sc-7gdahw-0 fJqNaH Radio__LabelRadio-sc-191s7yy-2 hFQfGJ bc-component">
                                      <span
                                        color="grey.700"
                                        className="Text__BCTextRoot-shaear-0 cjUHfn"
                                      >
                                        Suppressed
                                      </span>
                                    </div>
                                  </label>
                                  <label
                                    className="Box__BoxRoot-sc-7gdahw-0 gRlvMz Flex__FlexRoot-iew4t-0 Radio__WrapperRadio-sc-191s7yy-0 uJBon bc-component"
                                    display="flex"
                                    width="max-content"
                                  >
                                    <input
                                      name="checkStatus"
                                      type="radio"
                                      className="Radio__HiddenRadio-sc-191s7yy-1 gWDgbZ"
                                      defaultValue="FixPending"
                                    />
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 kgVoLO Radio__RadioRoot-sc-191s7yy-3 lafHvY bc-component"
                                      color="secondary"
                                      aria-checked="false"
                                    />
                                    <div className="Box__BoxRoot-sc-7gdahw-0 fJqNaH Radio__LabelRadio-sc-191s7yy-2 hFQfGJ bc-component">
                                      <span
                                        color="grey.700"
                                        className="Text__BCTextRoot-shaear-0 cjUHfn"
                                      >
                                        Fix Pending
                                      </span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 FilterSection__Root-sc-18ts49r-0 bCtSFH bc-component"
                          display="flex"
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 fEaIng bc-component">
                            <div
                              className="Box__BoxRoot-sc-7gdahw-0 glgcNz Flex__FlexRoot-iew4t-0 ePZMDm FilterContainer__StyledContainer-qjk6kn-0 gjFkrA bc-component"
                              display="flex"
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 eCACOE Flex__FlexRoot-iew4t-0 bc-component"
                                display="flex"
                              >
                                <span
                                  color="grey.700"
                                  className="Text__BCTextRoot-shaear-0 fCMqan"
                                >
                                  Code Categories
                                </span>
                              </div>
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 gVjYRm Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                display="flex"
                              >
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Code Categories"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="IacMisconfiguration"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      IaC Misconfiguration
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Code Categories"
                                >
                                  <input
                                    aria-checked="true"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="Vulnerabilities"
                                    defaultChecked=""
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 eAVGij bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="visible"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 fDxNSG"
                                    >
                                      Vulnerabilities
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Code Categories"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="Licenses"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Licenses
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Code Categories"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="Secrets"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Secrets
                                    </span>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 FilterSection__Root-sc-18ts49r-0 bCtSFH bc-component"
                          display="flex"
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 fEaIng bc-component">
                            <div
                              className="Box__BoxRoot-sc-7gdahw-0 glgcNz Flex__FlexRoot-iew4t-0 ePZMDm FilterContainer__StyledContainer-qjk6kn-0 gjFkrA bc-component"
                              display="flex"
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 eCACOE Flex__FlexRoot-iew4t-0 bc-component"
                                display="flex"
                              >
                                <span
                                  color="grey.700"
                                  className="Text__BCTextRoot-shaear-0 fCMqan"
                                >
                                  Severities
                                </span>
                              </div>
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 gVjYRm Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                display="flex"
                              >
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Severities"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="CRITICAL"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Critical
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Severities"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="HIGH"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      High
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Severities"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="MEDIUM"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Medium
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Severities"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="LOW"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Low
                                    </span>
                                  </div>
                                </label>
                                <label
                                  className="Box__BoxRoot-sc-7gdahw-0 efZjdn Checkbox__CheckboxWrapper-sc-1oy8ezk-1 hlgray bc-component"
                                  label="Severities"
                                >
                                  <input
                                    aria-checked="false"
                                    type="checkbox"
                                    className="Checkbox__HiddenCheckbox-sc-1oy8ezk-3 kwPklv"
                                    defaultValue="INFO"
                                  />
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                    display="flex"
                                  >
                                    <div className="Box__BoxRoot-sc-7gdahw-0 gUEaPd Checkbox__CheckboxRoot-sc-1oy8ezk-0 gIvERc bc-component">
                                      <svg
                                        viewBox="0 0 24 24"
                                        visibility="hidden"
                                        className="Checkbox__Icon-sc-1oy8ezk-2 dudngq"
                                      >
                                        <polyline points="20 6 9 17 4 12" />
                                      </svg>
                                    </div>
                                    <span
                                      color="grey.700"
                                      className="Text__BCTextRoot-shaear-0 cjUHfn"
                                    >
                                      Informational
                                    </span>
                                  </div>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Box__BoxRoot-sc-7gdahw-0 grjLnb bc-component">
                        <div className="Box__BoxRoot-sc-7gdahw-0 djRFXj bc-component">
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER bc-component">
                            <span>
                              <button className="LinkButton__LinkButtonRoot-zhdzys-1">
                                <span
                                  color="grey.700"
                                  fontWeight="semiBold"
                                  className="Text__BCTextRoot-shaear-0 oZWdS LinkButton__Content-zhdzys-0 eZQMZx"
                                >
                                  Add Filter
                                </span>
                              </button>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ position: "relative" }}>
                <div
                  role="presentation"
                  className="sc-jSMfEi kAODFL Resizer vertical SplitPane__StyledSplitPane-sc-10avc5m-0 jxDNWv"
                  style={{ width: "1rem" }}
                />
                <div
                  className="sc-gKXOVf hVANpd"
                  style={{
                    opacity: 1,
                    width: 1,
                    background: "rgb(232, 234, 239)",
                    zIndex: 10,
                    transition: "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                  }}
                />
                <div
                  className="sc-gKXOVf hVANpd"
                  style={{
                    opacity: 0,
                    visibility: "hidden",
                    width: 1,
                    background: "rgb(162, 160, 177)"
                  }}
                />
              </div>
              <div
                className="sc-bczRLJ doUjVv Pane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 jxDNWv"
                style={{ flexBasis: "952.8px" }}
              >
                <div
                  className="sc-dkzDqf jinsNC"
                  style={{ background: "rgba(220, 220, 220, 0.1)" }}
                />
                <div className="sc-gsnTZi GJlVj" style={{ minWidth: 50 }}>
                  <div
                    className="Box__BoxRoot-sc-7gdahw-0 hHkPkY Flex__FlexRoot-iew4t-0 bc-component"
                    display="flex"
                    height="100%"
                    overflow="auto"
                  >
                    <div
                      className="Box__BoxRoot-sc-7gdahw-0 ySkNt Flex__FlexRoot-iew4t-0 bc-component"
                      display="flex"
                    >
                      <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 gxKrjS Flex__FlexRoot-iew4t-0 fQPitA BCManageViewsTabs__ManageViewsTabsRoot-sc-4wkeqx-0 ljnbgW bc-component"
                          display="flex"
                          height={70}
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="Overview"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                Overview
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="IaC Misconfiguration"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                IaC Misconfiguration
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="Vulnerabilities"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                Vulnerabilities
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="Secrets"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                Secrets
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="Licenses"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                Licenses
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="VCS Pull Requests"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                VCS Pull Requests
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="grey.700"
                                title="CI/CD Runs"
                                className="Text__BCTextRoot-shaear-0 fDxNSG BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                CI/CD Runs
                              </span>
                            </span>
                          </div>
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER BCManageViewsTab__StyledMenu-kou0s8-1 iOdGtX bc-component">
                            <span>
                              <span
                                color="secondary"
                                title="Copy of Vulnerabilities"
                                className="Text__BCTextRoot-shaear-0 cHEhjp BCManageViewsTab__TabRoot-kou0s8-0 fwLTba"
                              >
                                Copy of Vulnerabilities
                              </span>
                            </span>
                          </div>
                          <div
                            className="Box__BoxRoot-sc-7gdahw-0 dFuVBm Flex__FlexRoot-iew4t-0 hWlBlw BCManageViewsTabs__AddViewContainer-sc-4wkeqx-1 hUoaZd bc-component"
                            display="flex"
                          >
                            <svg
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="far"
                              data-icon="plus-square"
                              className="svg-inline--fa fa-plus-square fa-w-14 FaIcon__RootFontAwesomeIcon-sc-1o9dktm-0 gXwYHl"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 448 512"
                              aria-label="plus-square"
                              color="secondary"
                            >
                              <path
                                fill="currentColor"
                                d="M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                              />
                            </svg>
                            <span
                              color="secondary"
                              fontSize="11px"
                              fontWeight="bold"
                              className="Text__BCTextRoot-shaear-0 eMKzZt Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                            >
                              <span>ADD VIEW</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="Box__BoxRoot-sc-7gdahw-0 iSCtoW bc-component">
                        <div
                          className="Box__BoxRoot-sc-7gdahw-0 khjZgp Flex__FlexRoot-iew4t-0 bc-component"
                          display="flex"
                          data-testid="bc-header"
                          height={70}
                          style={{ borderBottom: "none" }}
                        >
                          <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Menu__MenuRoot-cderkh-0 bQyzER bc-component">
                            <button
                              className="Box__BoxRoot-sc-7gdahw-0 hUBshy Flex__FlexRoot-iew4t-0 DefaultToggle__Toggle-sc-1s80y4c-1 ernqyU bc-component"
                              display="flex"
                              size={30}
                            >
                              <i
                                className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                display="flex"
                              >
                                <svg
                                  viewBox="0 0 15 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="DefaultToggle__MoreDetailsIcon-sc-1s80y4c-0 kjoKyn Icon__IconGraphics-sc-384m4t-0 kEFxEX"
                                  width={12}
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M13.498 9a1.5 1.5 0 110-2.999 1.5 1.5 0 010 2.999zM7.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                    fill="#17123B"
                                  />
                                </svg>
                              </i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="Box__BoxRoot-sc-7gdahw-0 cYmCdh bc-component"
                      overflow="auto"
                    >
                      <div className="SplitPane__Root-sc-10avc5m-1 korzRb">
                        <div className="sc-iBkjds ecJpcq SplitPane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 itNFDm">
                          <div
                            className="sc-bczRLJ doUjVv Pane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 itNFDm"
                            style={{ flexBasis: 398 }}
                          >
                            <div
                              className="sc-dkzDqf jinsNC"
                              style={{ background: "rgba(220, 220, 220, 0.1)" }}
                            />
                            <div
                              className="sc-gsnTZi GJlVj"
                              style={{ minWidth: 50 }}
                            >
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 bZPoIq Flex__FlexRoot-iew4t-0 MainSectionRouter__MainSectionWrapper-sc-1jxojtp-0 eEWIjc bc-component"
                                display="flex"
                                height="100%"
                              >
                                <div className="Box__BoxRoot-sc-7gdahw-0 jcaofs bc-component">
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 eeThiy Flex__FlexRoot-iew4t-0 gztbsu ViewOptions__ViewOptionsWrapper-nd9w-0 gTOpRo bc-component"
                                    display="flex"
                                  >
                                   <div style={{display:"flex", gap:"4px"}}>
                                    <VeltPresence/>
                                    <VeltHuddleTool/>
                                    <VeltCommentTool/>
                                    <VeltSidebarButton/>
                                  </div>
                                    
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 dBlSJF Flex__FlexRoot-iew4t-0 bc-component"
                                      display="flex"
                                    >
                                   
                                      <div className="Box__BoxRoot-sc-7gdahw-0 foBYJw bc-component" />
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 fmrtEB Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                        display="flex"
                                        
                                      >
                                        <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM BCSelectWithoutSearch__Root-sc-11kdnlx-0 cWEcqt bc-component">
                                          <div
                                          
                                            className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component"
                                            id="downshift-0-toggle-button"
                                            aria-haspopup="listbox"
                                            aria-expanded="false"
                                            aria-labelledby="downshift-0-label downshift-0-toggle-button"
                                          >
                                            <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                              <button 
                                                className="Box__BoxRoot-sc-7gdahw-0 ebRxGE Flex__FlexRoot-iew4t-0 BCSelectToggle__Root-sc-182zso2-1 bFzGge bc-component"
                                                display="flex"
                                                type="button"
                                                width="100%"
                                                height={38}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjhQdt Flex__FlexRoot-iew4t-0 fVShnb BCSelectToggle__SelectedContent-sc-182zso2-0 dzzFfB bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    
                                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                                    display="flex"
                                                  >
                                                    <span
                                                      
                                                      color="grey.700"
                                                      data-state="tooltip-hidden"
                                                      data-reach-tooltip-trigger=""
                                                      className="Text__BCTextRoot-shaear-0 cjUHfn Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                    >
                                                      <span>
                                                        Sorted by: Severity
                                                      </span>
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 dbsjGM styled__ToggleButton-s2ioeg-0 VDjsJ bc-component"
                                                    role="img"
                                                  >
                                                    <i
                                                      className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                                      display="flex"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 16.969 16.969"
                                                        className="Icon__IconGraphics-sc-384m4t-0 docJds"
                                                      >
                                                        <path
                                                          d="M16.509 6.143l-6.926 6.869a1.561 1.561 0 01-2.2 0L.457 6.143a1.544 1.544 0 010-2.19 1.561 1.561 0 012.2 0l5.827 5.774 5.827-5.774a1.56 1.56 0 012.2 0 1.544 1.544 0 01-.002 2.19z"
                                                          fillRule="evenodd"
                                                        />
                                                      </svg>
                                                    </i>
                                                  </div>
                                                </div>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM BCSelectWithoutSearch__Root-sc-11kdnlx-0 cWEcqt bc-component">
                                          
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component"
                                            id="downshift-1-toggle-button"
                                            aria-haspopup="listbox"
                                            aria-expanded="false"
                                            aria-labelledby="downshift-1-label downshift-1-toggle-button"
                                          >
                                            <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                              <button
                                                className="Box__BoxRoot-sc-7gdahw-0 ebRxGE Flex__FlexRoot-iew4t-0 BCSelectToggle__Root-sc-182zso2-1 bFzGge bc-component"
                                                display="flex"
                                                type="button"
                                                width="100%"
                                                height={38}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjhQdt Flex__FlexRoot-iew4t-0 fVShnb BCSelectToggle__SelectedContent-sc-182zso2-0 dzzFfB bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 fVShnb bc-component"
                                                    display="flex"
                                                  >
                                                    <span
                                                      color="grey.700"
                                                      data-state="tooltip-hidden"
                                                      data-reach-tooltip-trigger=""
                                                      className="Text__BCTextRoot-shaear-0 cjUHfn Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                    >
                                                      <span>
                                                        Grouped by: Resource
                                                      </span>
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 dbsjGM styled__ToggleButton-s2ioeg-0 VDjsJ bc-component"
                                                    role="img"
                                                  >
                                                    <i
                                                      className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                                      display="flex"
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 16.969 16.969"
                                                        className="Icon__IconGraphics-sc-384m4t-0 docJds"
                                                      >
                                                        <path
                                                          d="M16.509 6.143l-6.926 6.869a1.561 1.561 0 01-2.2 0L.457 6.143a1.544 1.544 0 010-2.19 1.561 1.561 0 012.2 0l5.827 5.774 5.827-5.774a1.56 1.56 0 012.2 0 1.544 1.544 0 01-.002 2.19z"
                                                          fillRule="evenodd"
                                                        />
                                                      </svg>
                                                    </i>
                                                  </div>
                                                </div>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="Box__BoxRoot-sc-7gdahw-0 bfzZqU bc-component">
                                      
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 bnXOqp bc-component"
                                        size={12}
                                      >
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 loKbRj Flex__FlexRoot-iew4t-0 Search__SearchRoot-sc-1capqwa-1 ciVEoa bc-component"
                                          display="flex"
                                          role="search"
                                        >
                                          
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Search__IconWrapper-sc-1capqwa-0 hAPZVh bc-component"
                                            display="flex"
                                            role="button"
                                            data-state="tooltip-hidden"
                                            data-reach-tooltip-trigger=""
                                          >
                                            <i
                                              className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Icon__IconRoot-sc-384m4t-1 fMPaoi bc-component"
                                              display="flex"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 15.031 15.031"
                                                className="Icon__IconGraphics-sc-384m4t-0 cuZydI"
                                                aria-label="Search"
                                              >
                                                <path
                                                  d="M14.815 14.815a.739.739 0 01-1.044 0l-2.989-2.984a6.642 6.642 0 111.049-1.048l2.989 2.988a.739.739 0 01-.005 1.044zM10.291 2.984a5.167 5.167 0 100 7.307 5.167 5.167 0 000-7.307z"
                                                  fillRule="evenodd"
                                                />
                                              </svg>
                                            </i>
                                          </div>
                                          
                                        </div>
                                        
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM LoadingStates__BoxWrapper-sc-5gui5q-1 cMWEMN bc-component">
                                 
                               
                                  <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                    <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM DecisionBoxSkeleton__Wrapper-sc-1ilh7mo-0 kAsEQg bc-component">
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 gOsvxn Flex__FlexRoot-iew4t-0 hGyWLD bc-component"
                                        display="flex"
                                      >
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 bWZQWr Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                          display="flex"
                                        >
                                          <div className="Box__BoxRoot-sc-7gdahw-0 eIvabE bc-component">
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                width={60}
                                                height={15}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="Box__BoxRoot-sc-7gdahw-0 iSCtoW bc-component" />
                                      </div>
                                    </div>
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 dZEEKS bc-component"
                                      overflow="auto"
                                    >
                                      <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM DecisionBoxSkeleton__Wrapper-sc-1ilh7mo-0 kAsEQg bc-component">
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                          display="flex"
                                        >
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                            width={60}
                                            height={15}
                                          />
                                        </div>{" "}
                                      </div>
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 kRqrun Table__Scrollable-sc-5jhxkl-0 hoWlfI bc-component"
                                        fontSize="small"
                                        role="table"
                                        style={{ minWidth: 0 }}
                                      >
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Header__Root-c9f1po-0 gggHeT bc-component"
                                          display="flex"
                                          role="rowgroup"
                                        >
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 cOQBYr Flex__FlexRoot-iew4t-0 HeaderRow__Root-sc-11fd65f-0 grFhEh bc-component"
                                            display="flex"
                                            role="row"
                                            fontSize="xsmall"
                                            height={40}
                                            style={{
                                              display: "flex",
                                              flex: "1 0 auto",
                                              minWidth: 0
                                            }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 jAoUCc HeaderCell__Root-sc-1rxdr1u-1 ghowmx bc-component"
                                              colSpan={1}
                                              role="columnheader"
                                              style={{
                                                boxSizing: "border-box",
                                                flex: "150 0 auto",
                                                minWidth: 0,
                                                width: 150
                                              }}
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 kHQJPd Flex__FlexRoot-iew4t-0 bc-component"
                                                display="flex"
                                                title=""
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 dRDhgg Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                >
                                                  <span
                                                    color="grey.600"
                                                    className="Text__BCTextRoot-shaear-0 clKfmW Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                  >
                                                    <span>&nbsp;</span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Body__BodyRoot-tbj2ae-0 dQeoto bc-component"
                                          role="rowgroup"
                                          aria-busy="true"
                                          aria-label="Table Body"
                                        >
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 duPxcv Flex__FlexRoot-iew4t-0 Row__Root-hgo21o-1 XflWW bc-component"
                                            display="flex"
                                            fontSize="small"
                                            aria-selected="false"
                                            role="row"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ikOIjY Flex__FlexRoot-iew4t-0 Row__CellsRoot-hgo21o-0 fMhigB bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 cPqana Flex__FlexRoot-iew4t-0 Cell__Root-z7brot-0 eYTzGW bc-component"
                                                display="flex"
                                                role="cell"
                                                style={{
                                                  boxSizing: "border-box",
                                                  flex: "150 0 auto",
                                                  minWidth: 0,
                                                  width: 150
                                                }}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 daqQqu Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                  overflow="hidden"
                                                  color="grey.700"
                                                  fontWeight="regular"
                                                  fontSize="xsmall"
                                                  fontFamily="body"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 duPxcv Flex__FlexRoot-iew4t-0 Row__Root-hgo21o-1 XflWW bc-component"
                                            display="flex"
                                            fontSize="small"
                                            aria-selected="false"
                                            role="row"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ikOIjY Flex__FlexRoot-iew4t-0 Row__CellsRoot-hgo21o-0 fMhigB bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 cPqana Flex__FlexRoot-iew4t-0 Cell__Root-z7brot-0 eYTzGW bc-component"
                                                display="flex"
                                                role="cell"
                                                style={{
                                                  boxSizing: "border-box",
                                                  flex: "150 0 auto",
                                                  minWidth: 0,
                                                  width: 150
                                                }}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 daqQqu Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                  overflow="hidden"
                                                  color="grey.700"
                                                  fontWeight="regular"
                                                  fontSize="xsmall"
                                                  fontFamily="body"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 duPxcv Flex__FlexRoot-iew4t-0 Row__Root-hgo21o-1 XflWW bc-component"
                                            display="flex"
                                            fontSize="small"
                                            aria-selected="false"
                                            role="row"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ikOIjY Flex__FlexRoot-iew4t-0 Row__CellsRoot-hgo21o-0 fMhigB bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 cPqana Flex__FlexRoot-iew4t-0 Cell__Root-z7brot-0 eYTzGW bc-component"
                                                display="flex"
                                                role="cell"
                                                style={{
                                                  boxSizing: "border-box",
                                                  flex: "150 0 auto",
                                                  minWidth: 0,
                                                  width: 150
                                                }}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 daqQqu Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                  overflow="hidden"
                                                  color="grey.700"
                                                  fontWeight="regular"
                                                  fontSize="xsmall"
                                                  fontFamily="body"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 duPxcv Flex__FlexRoot-iew4t-0 Row__Root-hgo21o-1 XflWW bc-component"
                                            display="flex"
                                            fontSize="small"
                                            aria-selected="false"
                                            role="row"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ikOIjY Flex__FlexRoot-iew4t-0 Row__CellsRoot-hgo21o-0 fMhigB bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 cPqana Flex__FlexRoot-iew4t-0 Cell__Root-z7brot-0 eYTzGW bc-component"
                                                display="flex"
                                                role="cell"
                                                style={{
                                                  boxSizing: "border-box",
                                                  flex: "150 0 auto",
                                                  minWidth: 0,
                                                  width: 150
                                                }}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 daqQqu Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                  overflow="hidden"
                                                  color="grey.700"
                                                  fontWeight="regular"
                                                  fontSize="xsmall"
                                                  fontFamily="body"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 duPxcv Flex__FlexRoot-iew4t-0 Row__Root-hgo21o-1 XflWW bc-component"
                                            display="flex"
                                            fontSize="small"
                                            aria-selected="false"
                                            role="row"
                                            style={{ cursor: "pointer" }}
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ikOIjY Flex__FlexRoot-iew4t-0 Row__CellsRoot-hgo21o-0 fMhigB bc-component"
                                              display="flex"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 cPqana Flex__FlexRoot-iew4t-0 Cell__Root-z7brot-0 eYTzGW bc-component"
                                                display="flex"
                                                role="cell"
                                                style={{
                                                  boxSizing: "border-box",
                                                  flex: "150 0 auto",
                                                  minWidth: 0,
                                                  width: 150
                                                }}
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 daqQqu Flex__FlexRoot-iew4t-0 bc-component"
                                                  display="flex"
                                                  overflow="hidden"
                                                  color="grey.700"
                                                  fontWeight="regular"
                                                  fontSize="xsmall"
                                                  fontFamily="body"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 iZuEce Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 butEGj Skeleton__SkeletonRoot-n96xdw-0 vwqsm bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style={{ position: "relative" }}>
                            <div
                              role="presentation"
                              className="sc-jSMfEi kAODFL Resizer vertical SplitPane__StyledSplitPane-sc-10avc5m-0 itNFDm"
                              style={{ width: "1rem" }}
                            />
                            <div
                              className="sc-gKXOVf hVANpd"
                              style={{
                                opacity: 1,
                                width: 1,
                                background: "rgb(232, 234, 239)",
                                zIndex: 10,
                                transition:
                                  "opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                              }}
                            />
                            <div
                              className="sc-gKXOVf hVANpd"
                              style={{
                                opacity: 0,
                                visibility: "hidden",
                                width: 1,
                                background: "rgb(162, 160, 177)"
                              }}
                            />
                          </div>
                          <div
                            className="sc-bczRLJ doUjVv Pane vertical SplitPane__StyledSplitPane-sc-10avc5m-0 itNFDm"
                            style={{ flexBasis: 199 }}
                          >
                            <div
                              className="sc-dkzDqf jinsNC"
                              style={{ background: "rgba(220, 220, 220, 0.1)" }}
                            />
                            <div
                              className="sc-gsnTZi GJlVj"
                              style={{ minWidth: 50 }}
                            >
                              <div className="Box__BoxRoot-sc-7gdahw-0 loRHox bc-component">
                                <div
                                  className="Box__BoxRoot-sc-7gdahw-0 jIDxir FixCart__FixCartRoot-sc-1x1bzrs-0 hUgrfi bc-component"
                                  overflow="hidden"
                                >
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 bgawP Flex__FlexRoot-iew4t-0 bc-component"
                                    display="flex"
                                    width="100%"
                                  >
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 FixCartSummary__FixCartSummaryWrapper-sc-1toh562-0 jsEVhi bc-component"
                                      display="flex"
                                    >
                                      <span
                                        color="grey.700"
                                        className="Text__BCTextRoot-shaear-0 cjUHfn Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                      >
                                        <span>
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 bc-component"
                                            display="flex"
                                          >
                                            <span
                                              color="grey.700"
                                              fontWeight="bold"
                                              className="Text__BCTextRoot-shaear-0 eDIBlC"
                                            >
                                              No issues have been added
                                            </span>
                                            <span
                                              color="grey.700"
                                              className="Text__BCTextRoot-shaear-0 bELeRe"
                                            >
                                              &nbsp;
                                            </span>
                                          </div>
                                        </span>
                                      </span>
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 kAIXvC Flex__FlexRoot-iew4t-0 ePZMDm bc-component"
                                        display="flex"
                                      >
                                        <button
                                          disabled=""
                                          className="Button__BCButtonRoot-rucsz4-1 dkgAyF bc-component"
                                        >
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Button__ButtonContent-rucsz4-0 eBYJtk bc-component"
                                            display="flex"
                                          >
                                            Submit
                                          </div>
                                        </button>
                                      </div>
                                    </div>
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Accordion__AccordionRoot-mhljbo-2 gbcni bc-component"
                                      aria-expanded="false"
                                    >
                                      <div
                                        className="Accordion__Content-mhljbo-0 izKWQP"
                                        style={{
                                          height: 0,
                                          overflow: "visible"
                                        }}
                                      >
                                        <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM Accordion__ContentWrapper-mhljbo-1 frGbcR bc-component" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="Box__BoxRoot-sc-7gdahw-0 cKyoVs bc-component"
                                height="90%"
                              >
                                <div
                                  className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Container__Root-sc-1v4101f-0 gGNzlN bc-component"
                                  display="flex"
                                  aria-label="Resource Explorer - Buildtime"
                                  aria-busy="true"
                                  aria-expanded="false"
                                >
                                  <div
                                    className="Box__BoxRoot-sc-7gdahw-0 hdqfhG Flex__FlexRoot-iew4t-0 Container__ContainerWrapper-sc-1v4101f-1 fsCgce bc-component"
                                    display="flex"
                                    width="100%"
                                  >
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 kgzaIa Flex__FlexRoot-iew4t-0 Title__TitleWrapperRoot-sc-17pef7a-0 BTWFW bc-component"
                                      display="flex"
                                    >
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 jxcCKJ Flex__FlexRoot-iew4t-0 bc-component"
                                        display="flex"
                                      >
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 gNabAN Flex__FlexRoot-iew4t-0 Skeleton__SquareSkeletonWrapper-sc-4uprxg-1 bc-component"
                                          display="flex"
                                        >
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 dunjxX Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                            size={18}
                                          />
                                        </div>
                                      </div>
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 bc-component"
                                        display="flex"
                                      >
                                        <div
                                          color="grey.700"
                                          className="Text__BCTextRoot-shaear-0 grRzzH Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                        >
                                          <span>
                                            <mark
                                              color="grey.700"
                                              type="bold"
                                              className="Text__BCTextRoot-shaear-0 hFWclP HighlightText__Token-sc-1uz9728-0 dwOJB"
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="Box__BoxRoot-sc-7gdahw-0 cXBlQc Flex__FlexRoot-iew4t-0 Styled__TabsWrapper-sc-1qhlqzj-0 cLWQNg bc-component"
                                      display="flex"
                                    >
                                      <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM bc-component">
                                        <div
                                          className="Box__BoxRoot-sc-7gdahw-0 ibBItw Flex__FlexRoot-iew4t-0 gztbsu bc-component"
                                          display="flex"
                                          overflow="auto"
                                        >
                                          <button
                                            id="re-details-tab"
                                            className="BCTab__ButtonTabStyled-sc-1w1d2ig-0 brjWwp"
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ebLOjM Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                            >
                                              <span
                                                color="secondary"
                                                fontWeight="medium"
                                                fontSize="small"
                                                className="Text__BCTextRoot-shaear-0 kmLqve Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                style={{
                                                  textTransform: "none"
                                                }}
                                              >
                                                <span>Details</span>
                                              </span>
                                            </div>
                                          </button>
                                          <button
                                            id="re-errors-tab"
                                            className="BCTab__ButtonTabStyled-sc-1w1d2ig-0 kisQJj"
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ebLOjM Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                            >
                                              <span
                                                color="grey.700"
                                                fontWeight="medium"
                                                fontSize="small"
                                                className="Text__BCTextRoot-shaear-0 dLCyBF Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                style={{
                                                  textTransform: "none"
                                                }}
                                              >
                                                <span>Issues</span>
                                              </span>
                                            </div>
                                          </button>
                                          <button
                                            id="re-history-tab"
                                            className="BCTab__ButtonTabStyled-sc-1w1d2ig-0 kisQJj"
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ebLOjM Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                            >
                                              <span
                                                color="grey.700"
                                                fontWeight="medium"
                                                fontSize="small"
                                                className="Text__BCTextRoot-shaear-0 dLCyBF Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                style={{
                                                  textTransform: "none"
                                                }}
                                              >
                                                <span>History</span>
                                              </span>
                                            </div>
                                          </button>
                                          <button
                                            id="re-traceability-tab"
                                            className="BCTab__ButtonTabStyled-sc-1w1d2ig-0 kisQJj"
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ebLOjM Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                            >
                                              <span
                                                color="grey.700"
                                                fontWeight="medium"
                                                fontSize="small"
                                                className="Text__BCTextRoot-shaear-0 dLCyBF Truncate__TruncateRoot-sc-1jh3wh5-0 gzrFec"
                                                style={{
                                                  textTransform: "none"
                                                }}
                                              >
                                                <span>Traceability</span>
                                              </span>
                                            </div>
                                          </button>
                                        </div>
                                      </div>
                                      <div
                                        className="Box__BoxRoot-sc-7gdahw-0 gvzOpE bc-component"
                                        aria-busy="true"
                                        aria-label="re-details-tab"
                                      >
                                        <div className="Box__BoxRoot-sc-7gdahw-0 dbsjGM StateManager__ContentWrapper-eoz2kz-0 bjwPwt bc-component">
                                          <div
                                            className="Box__BoxRoot-sc-7gdahw-0 iaKhxf Flex__FlexRoot-iew4t-0 bc-component"
                                            display="flex"
                                          >
                                            <div
                                              className="Box__BoxRoot-sc-7gdahw-0 ixomQU Flex__FlexRoot-iew4t-0 bc-component"
                                              display="flex"
                                              overflow="hidden"
                                              width="100%"
                                            >
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__AttributeWrapper-sc-1so0cdr-0 dayCXU bc-component"
                                                display="flex"
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjtPxh Flex__FlexRoot-iew4t-0 Attribute__LabelColumnWrapper-sc-1so0cdr-1 eWDsHq bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__ValueColumnWrapper-sc-1so0cdr-2 bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__AttributeWrapper-sc-1so0cdr-0 dayCXU bc-component"
                                                display="flex"
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjtPxh Flex__FlexRoot-iew4t-0 Attribute__LabelColumnWrapper-sc-1so0cdr-1 eWDsHq bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__ValueColumnWrapper-sc-1so0cdr-2 bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__AttributeWrapper-sc-1so0cdr-0 dayCXU bc-component"
                                                display="flex"
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjtPxh Flex__FlexRoot-iew4t-0 Attribute__LabelColumnWrapper-sc-1so0cdr-1 eWDsHq bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__ValueColumnWrapper-sc-1so0cdr-2 bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__AttributeWrapper-sc-1so0cdr-0 dayCXU bc-component"
                                                display="flex"
                                              >
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 jjtPxh Flex__FlexRoot-iew4t-0 Attribute__LabelColumnWrapper-sc-1so0cdr-1 eWDsHq bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  className="Box__BoxRoot-sc-7gdahw-0 hsaUko Flex__FlexRoot-iew4t-0 Attribute__ValueColumnWrapper-sc-1so0cdr-2 bc-component"
                                                  display="flex"
                                                >
                                                  <div
                                                    className="Box__BoxRoot-sc-7gdahw-0 gMKXkL Flex__FlexRoot-iew4t-0 bc-component"
                                                    display="flex"
                                                  >
                                                    <div
                                                      className="Box__BoxRoot-sc-7gdahw-0 hwdOKF Skeleton__SkeletonRoot-sc-4uprxg-0 jUvDBN bc-component"
                                                      width={60}
                                                      height={15}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <iframe
    allow="join-ad-interest-group"
    data-tagging-id="AW-640339088"
    data-load-time={1700260450464}
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://td.doubleclick.net/td/rul/640339088?random=1700260450460&cv=11&fst=1700260450460&fmt=3&bg=ffffff&guid=ON&async=1&gtm=45be3b81&gcd=11l1l1l1l1&dma=0&u_w=1512&u_h=982&url=https%3A%2F%2Fwww.bridgecrew.cloud%2Forganization&ref=https%3A%2F%2Fwww.bridgecrew.cloud%2Fprojects%3FviewId%3D8107fe4e-4891-492c-a9ce-f9d453a3d789&hn=www.googleadservices.com&frm=0&tiba=Bridgecrew%20%7C%20Console&auid=228304446.1700256682&fledge=1&data=event%3Dgtag.config"
  />
  <img
    src="https://t.co/i/adsct?bci=3&eci=2&event_id=2abba172-0ce0-4fe8-9334-b6cda06dcf2d&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Forganization&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
  <img
    src="https://analytics.twitter.com/i/adsct?bci=3&eci=2&event_id=2abba172-0ce0-4fe8-9334-b6cda06dcf2d&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Forganization&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
  <div>
    <div className="ToastContainer__Root-sc-1vw5ufo-0 hqsDpc App__AppToastContainer-vz1ed0-0 jElLtc" />
  </div>
  <iframe
    owner="archetype"
    title="archetype"
    style={{ display: "none", visibility: "hidden" }}
  />
  <superflow-toolbar
    apikey="cYuTd64lCzCoQvgqkv7g"
    projectid={635066039480862}
    className="expanded"
    data-velt-comment-disabled="true"
    style={{ zIndex: 2147483647 }}
  />
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 TtSa-D Popover__PopperElement-sc-9h3h9j-1 mSmKA bc-component"
      role="dialog"
      data-popper-reference-hidden="false"
      data-popper-escaped="false"
      data-popper-placement="right-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(90px, 778px, 0px)"
      }}
    />
  </div>
  <img
    src="https://t.co/i/adsct?bci=3&eci=2&event_id=9bcb03b8-8a95-4f37-9ef0-ac93f2d8fa9d&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Fprojects&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
  <img
    src="https://analytics.twitter.com/i/adsct?bci=3&eci=2&event_id=9bcb03b8-8a95-4f37-9ef0-ac93f2d8fa9d&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Fprojects&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(758px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(862px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(882px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(888px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(930px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(1022px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(1034px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="true"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(1139px, 100px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="false"
      data-popper-escaped="false"
      data-popper-placement="bottom-end"
      style={{
        position: "fixed",
        inset: "0px auto auto 0px",
        transform: "translate3d(1246px, 107px, 0px)"
      }}
    />
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 bUlvCK bc-component"
      width="71.84375"
      data-popper-reference-hidden="false"
      data-popper-escaped="false"
      data-popper-placement="bottom-start"
      style={{
        position: "absolute",
        inset: "0px auto auto 0px",
        transform: "translate3d(842px, 181px, 0px)"
      }}
    >
      <ul
        className="Box__BoxRoot-sc-7gdahw-0 eJQPWq Flex__FlexRoot-iew4t-0 List__ListRoot-sc-16as5ii-0 cAQgiP bc-component"
        display="flex"
        id="downshift-0-menu"
        role="listbox"
        aria-labelledby="downshift-0-label"
        tabIndex={-1}
        opacity={0}
        overflow="hidden"
      />
    </div>
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 gkTEaa bc-component"
      width="81.125"
      data-popper-reference-hidden="false"
      data-popper-escaped="false"
      data-popper-placement="bottom-start"
      style={{
        position: "absolute",
        inset: "0px auto auto 0px",
        transform: "translate3d(878px, 181px, 0px)"
      }}
    >
      <ul
        className="Box__BoxRoot-sc-7gdahw-0 eJQPWq Flex__FlexRoot-iew4t-0 List__ListRoot-sc-16as5ii-0 cAQgiP bc-component"
        display="flex"
        id="downshift-1-menu"
        role="listbox"
        aria-labelledby="downshift-1-label"
        tabIndex={-1}
        opacity={0}
        overflow="hidden"
      />
    </div>
  </div>
  <div>
    <div
      className="Box__BoxRoot-sc-7gdahw-0 fHThls bc-component"
      data-popper-reference-hidden="true"
      data-popper-escaped="true"
      data-popper-placement="top-start"
      style={{
        position: "fixed",
        inset: "auto auto 0px 0px",
        transform: "translate3d(110px, 76px, 0px)"
      }}
    />
  </div>
  <img
    src="https://t.co/i/adsct?bci=3&eci=2&event_id=e0b42c70-a4e0-4c34-abd1-bff515904d28&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Fprojects%3FviewId%3D8107fe4e-4891-492c-a9ce-f9d453a3d789&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
  <img
    src="https://analytics.twitter.com/i/adsct?bci=3&eci=2&event_id=e0b42c70-a4e0-4c34-abd1-bff515904d28&events=%5B%5B%22pageview%22%2C%7B%7D%5D%5D&integration=advertiser&p_id=Twitter&p_user_id=0&pl_id=15831404-03b1-479d-bee1-1af99fd2626a&tw_document_href=https%3A%2F%2Fwww.bridgecrew.cloud%2Fprojects%3FviewId%3D8107fe4e-4891-492c-a9ce-f9d453a3d789&tw_iframe_status=0&tw_order_quantity=0&tw_sale_amount=0&txn_id=o3nuq&type=javascript&version=2.3.29"
    height={1}
    width={1}
    style={{ display: "none" }}
  />
</>

  )
}

